import { ArrowRightIcon } from '@heroicons/react/outline';
import { Typography } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import NumberSection from './NumberSection';
import ButtonDefault, { ButtonVariants } from '../../shared/basic/button';
import animationData from '../../../../public/BookBG.gif';
import { NumberSectionData } from '../../../utils/data';

const IntoSection = () => {
  const screens = useBreakpoint();

  return (
    <>
      <div className='flex flex-col-reverse md:flex-row  w-full'>
        <div className='flex justify-center md:justify-start  w-full xl:w-2/5  items-center '>
          <div className='  flex justify-center items-center md:pl-12 lg:pl-24 text-fadedWhite'>
            <div className='w-4/5 xl:w-10/12 text-center md:text-start flex justify-center flex-col gap-y-4 xl:gap-y-9'>
              <Typography.Title
                level={1}
                className='text-3xl lg:text-5xl xl:text-[64px] leading-9 h-full font-medium'
              >
                India’s Most Innovative Books
              </Typography.Title>
              <span className='text-sm flex flex-col gap-y-4 xl:gap-y-6 xl:text-[20px] text-textGray font-medium leading-6'>
                {/* <span>Books for Business & Upskilling.</span> */}

                <Typography.Title
                  level={2}
                  className='italic font-norma text-white text-2xl'
                >
                  1,00,000+ Readers Trusted Zebralearn to Level up their
                </Typography.Title>
                <div className='flex justify-center md:justify-start mt-5'>
                  <span>
                    <Link href='/product'>
                      <ButtonDefault
                        size={!screens.md ? 4 : 1}
                        rounded={true}
                        variant={ButtonVariants.PRIMARY}
                        className='flex justify-center px-5 py-3  font-medium text-xs  whitespace-nowrap'
                      >
                        <span className='flex items-center gap-x-2 whitespace-nowrap lg:px-4 py-1 text-base'>
                          Explore Books! <ArrowRightIcon className='w-6 h-4' />
                        </span>
                      </ButtonDefault>
                    </Link>
                  </span>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div className='w-full xl:w-3/5 flex items-start '>
          <div className='w-full flex mb-28'>
            <Image src={animationData} alt='BookAnimation' />
          </div>
        </div>
      </div>
      <div
        className='pb-5 shadow-md'
        style={{
          boxShadow:
            '0px 4px 4px -1px rgba(0, 0, 0, 0.1), 0px -4px 4px -1px rgba(0, 0, 0, 0.1)',
        }}
      >
        <NumberSection data={NumberSectionData} />
      </div>
    </>
  );
};

export default IntoSection;
